module.exports = __webpack_public_path__ + "static/img/800.b3bb155.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/pop/800.png
// module id = TtJm
// module chunks = 2